import React from 'react';

const AboutUs = ({ setCurrentView }) => (
    <div id="aboutUsView" className="info-container">
        <h2>О нас</h2>
        <p>Добро пожаловать в наш криптообменник! Мы предоставляем быстрый, безопасный и удобный сервис для обмена криптовалюты. Наша цель — сделать процесс покупки, продажи и обмена USDT, пополнения Alipay/Wechat и перестановки наличных максимально простым для наших клиентов.</p>
        <p>Мы ценим ваше доверие и стремимся обеспечить высокий уровень обслуживания.</p>
        <button type="button" onClick={() => setCurrentView('mainMenu')}>Назад в главное меню</button>
    </div>
);

export default AboutUs;